import {
    ButtonSecondary,
    Card,
    Colors,
    Heading,
    Icon,
    Text,
    type IconName,
} from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

type NewTemplateCardProps = {
    iconName: IconName;
    title: string;
    description: string;
    onButtonClick: () => void;
    isCreatingTemplate?: boolean;
};

export const NewTemplateCard = ({
    iconName,
    title,
    description,
    onButtonClick,
    isCreatingTemplate,
}: NewTemplateCardProps) => {
    const { t } = useAmelioTranslations();

    const handleCardClick = () => {
        if (isCreatingTemplate) {
            return;
        }
        onButtonClick();
    };

    return (
        <Card
            className={'cursor-pointer border-2 border-dotted'}
            borderColor={Colors.BASE_300}
            borderRadius={'2xl'}
            onClick={handleCardClick}
        >
            <div className={'grow'}>
                <div className={'bg-primary w-fit rounded-md p-3'}>
                    <Icon
                        name={iconName}
                        size={32}
                        color={Colors.WHITE}
                    />
                </div>

                <Heading
                    level={6}
                    className={'mt-4'}
                >
                    {title}
                </Heading>

                <Text
                    className={'mt-2 w-1/2'}
                    size={'small'}
                >
                    {description}
                </Text>
            </div>

            <div className={'mt-8 flex w-full items-center justify-end gap-4'}>
                <ButtonSecondary
                    size={'sm'}
                    onClick={(event) => {
                        event.stopPropagation();
                        onButtonClick();
                    }}
                    loading={isCreatingTemplate}
                    disabled={isCreatingTemplate}
                    className={'border! px-2 py-2'}
                >
                    <Text
                        align={'center'}
                        className={'text-xs'}
                        weight={'medium'}
                    >
                        {t('evaluation360SelectTemplate.startBuilding')}
                    </Text>
                </ButtonSecondary>
            </div>
        </Card>
    );
};
